import React, { useContext, useEffect } from 'react';
import './Learning.scss';
import { FaHtml5, FaCss3Alt, FaJsSquare, FaReact } from 'react-icons/fa'; // Importing icons
import MyContext from '../Context/MyContext';
import { useNavigate } from 'react-router-dom';

const Learning = () => {

  
  const{token,fetchlearn ,learn,domain,usertoken}=useContext(MyContext)

  const Navigate=useNavigate()

  

  useEffect(()=>{
          !token ? Navigate('/login'):fetchlearn()
      },[])
 

  return (
    <div className="learning-container">

    {
      learn.filter((i) => i.domain === usertoken.domain&&usertoken.domain).length > 0 ? (
        learn
      .filter(i=>i.domain===usertoken.domain&&usertoken.domain)
      .map((o)=>{
        return(
          <>
          {
            o.resources

            .map((i)=>{
              return(
                <div 
                  key={i.id} 
                  className="learning-section" 
                  onClick={() => window.open(i.link, '_blank')}
                >
                
                  <h2 className="topic-title">{i.name}</h2>
                </div>
              )
            })
          }
          </>
        )
      })
  
        ):(
          <p className="no-data">No data available</p>
        )
        }
     
    </div>
  );
};

export default Learning;
